export default __webpack_public_path__ + "static/media/Group.3d0f695e.svg";